<template>
  <span>
    <template v-if="modo == 'new' || modo == 'edit' || modo == 'flow'">
      <v-select
        :items="items"
        item-text="v"
        item-value="k"
        v-bind:value="preLoad(value)"
        v-on:input="event => $emit('input', preUpdate(event))"
        required
        :multiple="getComponentParam('multi') * 1 == 1 ? true : false"
        clearable
        :rules="crud.evalrules(campo)"
        :hint="T(campo.cmp_dica)"
        persistent-hint
        background-color="#fcfcfc"
      ></v-select>
    </template>

    <template v-if="modo == 'list' || modo == 'view' || modo == 'viewmode'">{{
      valoramostrar
    }}</template>

    <template v-if="modo == 'filtro'">
      <v-select
        height="20"
        class="ma-0 pa-1"
        hide-details
        :items="items"
        item-text="v"
        item-value="k"
        clearable
        v-on:keyup.enter="onEnter"
        v-bind:value="preLoad(value)"
        v-on:input="event => $emit('input', preUpdate(event))"
        background-color="#fcfcfc"
      ></v-select>
    </template>
  </span>
</template>

<script>
try {
  var _baseComponent = require("@/lib/componente/_base.vue").default;
} catch (err) {
  var _baseComponent = require("@/framework/lib/componente/_base.vue").default;
}
export default {
  extends: _baseComponent,

  data() {
    return {};
  },
  computed: {
    items() {
      let array = this.campo.cmp_valores
        .split(",")
        .map(t => global.fn.T(t, null, null, this))
        .map((v, i) => ({ k: i, v: this.computeContaVal(v.trim()) }));

      if (this.getComponentParam("ordemfixa")) {
        let array2 = [];
        let lista = this.getComponentParam("ordemfixa")
          .split(",")
          .map((v, vi) => {
            array2.push(array[v * 1]);
          });
        return array2;
      }

      return array;
    },
    valoramostrar() {
      if (this.value === null) return "";

      if (this.getComponentParam("multi") * 1 == 1) {
        let els = this.value.split(",").map(v => v * 1);
        return els
          .map(v => {
            let sel = _.filter(this.items, { k: v });
            if (sel && sel[0]) return sel[0].v;
          })
          .join(", ");
      } else {
        let sel = _.filter(this.items, { k: this.value });
        if (sel && sel[0]) return sel[0].v;
      }
    }
  },
  methods: {
    preLoad(myval) {
      if (myval == undefined) return null;

      if (this.getComponentParam("multi") * 1 == 1) {
        return (myval + "").split(",").map(v => v * 1);
      }
      return myval;
    },
    preUpdate(myval) {
      return myval;
    }
  }
};
</script>

<style scoped></style>
